import { DELETE_LECTURE } from "./types";
import LecturesApi from "../api/LecturesApi";

export const deleteLecture = (courseId, id) => async dispatch => {
  try {
    await new LecturesApi().deleteLecture(id, courseId);
    dispatch({
      type: DELETE_LECTURE,
      payload: { courseId, id },
    });
  } catch (error) {
    if (error.response?.status === 403) {
      console.error("No tienes permisos para eliminar esta clase");
    } else {
      console.error("Error al eliminar la clase", error);
    }
    throw error;
  }
};
